import { withForm } from '@/core/form/withForm';
import { SvyCheckbox } from '@/components/savory/SvyCheckbox';

export const Checkbox = withForm(SvyCheckbox);
